import type { Metadata } from "next";
import { LegalLayout, LegalSection } from "@/components/legal/legal-layout";

export const metadata: Metadata = {
  title: "Chính sách bảo mật",
  description: "Tử Vi Số thu thập và sử dụng dữ liệu cá nhân của bạn như thế nào.",
};

export default function PrivacyPage() {
  return (
    <LegalLayout
      title="Chính sách bảo mật"
      subtitle="Tử Vi Số tôn trọng quyền riêng tư của người dùng và cam kết bảo vệ thông tin cá nhân."
      lastUpdated="30/05/2026"
    >
      <LegalSection title="1. Dữ liệu chúng tôi thu thập">
        <p>Khi bạn sử dụng dịch vụ, chúng tôi thu thập:</p>
        <ul className="ml-5 list-disc space-y-1.5">
          <li>
            <strong>Thông tin tài khoản:</strong> email, tên hiển thị, ảnh đại diện (nếu đăng nhập
            qua Google).
          </li>
          <li>
            <strong>Thông tin lá số:</strong> ngày sinh, giờ sinh, giới tính, năm sinh — chỉ dùng để
            tính lá số tử vi và phong thủy. Bạn có thể không cung cấp thông tin này, khi đó các tính
            năng cá nhân hoá sẽ không hoạt động.
          </li>
          <li>
            <strong>Lịch sử sử dụng:</strong> các công cụ đã dùng, câu hỏi gửi cho AI, lá số đã lưu
            — phục vụ tính năng dashboard cá nhân và cải thiện chất lượng dịch vụ.
          </li>
          <li>
            <strong>Dữ liệu kỹ thuật:</strong> địa chỉ IP, loại trình duyệt, thiết bị, log truy cập
            — phục vụ vận hành, chống lạm dụng và phân tích thống kê.
          </li>
        </ul>
      </LegalSection>

      <LegalSection title="2. Mục đích sử dụng">
        <ul className="ml-5 list-disc space-y-1.5">
          <li>Cung cấp các công cụ tử vi, phong thủy, lịch âm và luận giải AI.</li>
          <li>Lưu trữ lá số và lịch sử để bạn xem lại sau, cá nhân hoá trải nghiệm.</li>
          <li>Gửi thông báo dịch vụ (xác thực email, nhắc ngày tốt nếu bạn bật).</li>
          <li>Phân tích thống kê tổng hợp (không định danh) để cải thiện sản phẩm.</li>
          <li>Tuân thủ nghĩa vụ pháp lý theo quy định pháp luật Việt Nam.</li>
        </ul>
      </LegalSection>

      <LegalSection title="3. Chia sẻ với bên thứ ba">
        <p>
          Chúng tôi <strong>không bán</strong> dữ liệu cá nhân. Một số dịch vụ phụ trợ:
        </p>
        <ul className="ml-5 list-disc space-y-1.5">
          <li>
            <strong>OpenAI / Anthropic:</strong> nội dung câu hỏi và lá số được gửi qua API để sinh
            phản hồi. Theo chính sách OpenAI, dữ liệu API không dùng để train model.
          </li>
          <li>
            <strong>Google OAuth:</strong> dùng để đăng nhập, theo chính sách Google.
          </li>
          <li>
            <strong>Resend:</strong> gửi email xác thực và thông báo dịch vụ.
          </li>
          <li>
            <strong>Google Analytics 4:</strong> thu thập dữ liệu thống kê tổng hợp (đã ẩn danh IP,
            không bao gồm thông tin lá số).
          </li>
        </ul>
      </LegalSection>

      <LegalSection title="4. Bảo mật">
        <p>
          Dữ liệu được lưu trên máy chủ riêng đặt tại Việt Nam, mã hóa kết nối HTTPS toàn site, mật
          khẩu hash bằng bcrypt, sao lưu định kỳ. Tuy vậy không có hệ thống nào tuyệt đối an toàn —
          vui lòng dùng mật khẩu mạnh và không chia sẻ tài khoản.
        </p>
      </LegalSection>

      <LegalSection title="5. Quyền của bạn">
        <ul className="ml-5 list-disc space-y-1.5">
          <li>Truy cập, sửa đổi, xóa thông tin cá nhân trong trang Dashboard.</li>
          <li>Xóa toàn bộ tài khoản (gửi email yêu cầu).</li>
          <li>Tải bản sao dữ liệu cá nhân (xuất JSON).</li>
          <li>Rút lại sự đồng ý sử dụng dữ liệu bất cứ lúc nào.</li>
        </ul>
      </LegalSection>

      <LegalSection title="6. Trẻ em">
        <p>
          Dịch vụ không dành cho trẻ em dưới 16 tuổi. Nếu phát hiện tài khoản của trẻ em, chúng tôi
          sẽ xoá ngay khi nhận được thông báo.
        </p>
      </LegalSection>

      <LegalSection title="7. Liên hệ">
        <p>
          Mọi thắc mắc về chính sách bảo mật hoặc yêu cầu xử lý dữ liệu, gửi về:{" "}
          <a href="mailto:privacy@tuvi-so.example" className="text-brand-gold hover:underline">
            privacy@tuvi-so.example
          </a>
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
